import { isEmpty } from 'lodash';

import config from 'config/config';

export default (values, localizableFields, confirmMessage) => {
    const languages = config.app.languages.filter(lang => lang !== config.app.defaultLanguage);
    const emptyLanguages = [];
    for (const lang of languages) {
        for (const field of localizableFields) {
            if (isEmpty(values[lang][field]) && !isEmpty(values[config.app.defaultLanguage][field])) {
                emptyLanguages.push(lang);
                break;
            }
        }
    }
    return isEmpty(emptyLanguages) || window.confirm(confirmMessage);
};
